import useAuthForm from "../hooks/useAuthForm"

// Per-mode copy for the headings, button and the cross-link to the other screen.
const COPY = {
  login: {
    heading: "Привіт!",
    subtitle: "Щоб увійти, введи свою електронну пошту та пароль.",
    submit: "Увійти",
    altText: "Ще немає акаунту?",
    altLink: "Зареєструйся",
  },
  signup: {
    heading: "Вітаємо!",
    subtitle: "Створи акаунт, щоб зібрати власну книжкову полицю.",
    submit: "Створити акаунт",
    altText: "Вже маєш акаунт?",
    altLink: "Увійти",
  },
}

// Big, clean input with the label used as the placeholder (BonSanté style).
// The label stays in the DOM, visually hidden, so the field remains accessible.
const Field = ({ field, value, error, onChange, autoFocus }) => (
  <div className={`auth-field${error ? " is-error" : ""}`}>
    <label className="sr-only" htmlFor={`auth_${field.name}`}>{field.label}</label>
    <input
      id={`auth_${field.name}`}
      type={field.type}
      value={value}
      placeholder={field.label}
      autoFocus={autoFocus}
      autoComplete={field.autoComplete}
      onChange={(e) => onChange(field.name, e.target.value)}
    />
    <div className="auth-field__error" aria-live="polite">{error}</div>
  </div>
)

const AuthForm = ({ config }) => {
  const { fields, values, errors, status, formError, shake, change, submit } =
    useAuthForm(config)
  const copy = COPY[config.mode]

  return (
    <div className={`auth auth--${config.mode}`}>
      {/* Left: the form */}
      <section className="auth__pane">
        <div className={`auth__box${shake ? " is-shaking" : ""}`}>
          <h1 className="auth__title">{copy.heading}</h1>
          <p className="auth__subtitle">{copy.subtitle}</p>

          <form className="auth__form" onSubmit={submit} noValidate>
            {formError && <div className="cf-form-error">{formError}</div>}

            {fields.map((field, i) => (
              <Field
                key={field.name}
                field={field}
                value={values[field.name]}
                error={errors[field.name]}
                onChange={change}
                autoFocus={i === 0}
              />
            ))}

            <button
              type="submit"
              className={`btn cf-submit cf-submit--${status} auth__submit`}
              disabled={status !== "idle"}
            >
              <span className="cf-submit__label">{copy.submit}</span>
              <span className="cf-submit__spinner" aria-hidden="true" />
              <span className="cf-submit__check" aria-hidden="true">✓</span>
            </button>
          </form>

          <p className="auth__alt">
            {copy.altText} <a href={config.alt_href}>{copy.altLink}</a>
          </p>
        </div>
      </section>

      {/* Right: media panel with overlay card */}
      <aside className="auth__media">
        <img className="auth__logo" src="/citaria-logo.png" alt="citaria" />
        <div className="auth__media-card">
          <h2 className="auth__media-title">Твоя книжкова полиця чекає</h2>
          <p className="auth__media-text">
            Збирай прочитане, відкривай нове й повертайся до улюблених сторінок —
            усе в одному затишному місці.
          </p>
        </div>
      </aside>
    </div>
  )
}

export default AuthForm
